import React from 'react'
import { getLiveApi } from './api'
import { ExtensionResponse } from '../common/types/api/LiveExtensionsResponse'

import GlobalNotification from 'live/services/global-notification'
import { Notification } from '../common/components/Notification/Notification'
import i18n from 'live/services/i18n'

export default async function getSMTPConfigurations(): Promise<string[]> {
    try {
        const extensionsResponse = await getLiveApi<ExtensionResponse>('extension?area=INTEGRATION')

        const extensions = extensionsResponse.extensions
        const smtpConfigs = []

        smtpConfigs.push('default')

        if (extensions) {
            extensions.forEach(extension => {
                const isSMTPConfig = extension.type === 'smtp'
                if (isSMTPConfig) smtpConfigs.push(extension.fullQualifier)
            })
        }

        return smtpConfigs
    } catch (error) {
        GlobalNotification.error(
            <Notification title={i18n('Error trying to get SMTP configuration:')}>{error}</Notification>,
            20
        )

        console.error(error)

        return []
    }
}
